import React from "react";
import TabsLayout from "../../component/Layout/SubmitFeature/Tabs";

const SubmitFeaturePage = () => {
  return (
    <div>
      <TabsLayout />
    </div>
  );
};

export default SubmitFeaturePage;


